import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Modal,
} from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import { editEmployeeApi, employeeChangePasswordApi } from "../../../services/apis/EmployeeApi";
import { getUserDetailApi } from "../../../services/apis/AuthService";
import { UserDataAction } from "../../../store/actions/UserAction";
import Swal from "sweetalert2";
import { Toaster } from "../../components/Toaster/Toster";
import BtnLoader from "../../components/Loader/btnLoader";
import apis from "../../../services/apis";
import { ToastContainer } from "react-toastify";
import { FaArrowLeft, FaEye, FaEyeSlash } from "react-icons/fa";
import userAvatar from "../../../assets/images/avatar2.jpg";
import { UpdateAdminProfileApi } from "../../../services/apis/UserProfile";



const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    mobile: "",
    email: "",
    profileImage: "",
  });
  const [userD, setUserD] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [modalCentered, setModalCentered] = useState(false);
  const [uploadProfileUrl, setUploadProfileUrl] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);
  // password change
  const [passwordFormData, setPasswordFormData] = useState({
    old_password: "",
    password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState({
    old_password: false,
    password: false,
    confirm_password: false,
  });
  const [passwordBtn, setPasswordBtn] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({});

  const getUserInfo = async () => {
    try {
      const response = await getUserDetailApi();
      const uData = response?.data?.data;
      setUserD(uData);
      setProfileUrl(uData?.profileImage || "");
      setFormData({
        firstName: uData?.firstName,
        lastName: uData?.lastName,
        mobile: uData?.mobile?.toString(),
        email: uData?.email,
        profileImage: uData?.profileImage,
        username: uData?.username,
      });
      //console.log("response", uData);
      dispatch(UserDataAction(uData));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadProfileUrl(URL.createObjectURL(file)); // Generate a local URL for the uploaded image
      setFormData({ ...formData, profileImage: file });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData?.firstName?.trim())
      newErrors.firstName = "First Name is required.";
    if (!formData?.lastName?.trim())
      newErrors.lastName = "Last Name is required.";
    if (!formData?.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.email = "Invalid email.";
    if (!formData?.mobile) newErrors.mobile = "Mobile number is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      username: "",
      mobile: "+91",
      email: "",
      profileImage: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const fData = {
        ...formData,
        username: `${formData?.firstName}${formData?.lastName}`,
      };
      setBtnLoading(true);
      try {
        const res = await UpdateAdminProfileApi(userD?._id, fData);
        const resData = res?.data;
        getUserInfo();
        if (resData?.success) {
          Swal.fire({
            icon: "success",
            title: "Profile Updated Successful",
            //  text: res?.data?.message
          });
          resetForm();
          navigate("/app-profile");
        }
      } catch (err) {
        console.log(err);
        Toaster.error(err?.response?.data?.message);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handlePhoneNoChange = (value, country) => {
    const phoneNum = value?.slice(2);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    setFormData({
      ...formData,
      mobile: phone,
    });
  };

  // password change
  const handlePasswordInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordFormData({ ...passwordFormData, [name]: value });
  };

  // Form validation
  const validatePasswordForm = () => {
    let newErrors = {};

    if (!passwordFormData.old_password)
      newErrors.old_password = "Old password is required";

    if (!passwordFormData.password) {
      newErrors.password = "New password is required";
    } else if (passwordFormData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long";
    }

    if (passwordFormData.password !== passwordFormData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    setPasswordErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handlePasswordSubmit = async () => {
    if (validatePasswordForm()) {
      try {
        const res = await employeeChangePasswordApi(passwordFormData);
        const resData = res?.data;
        if (resData?.success) {
          Toaster.success(resData?.message);
          setModalCentered(false);
          setPasswordFormData({
            old_password: "",
            password: "",
            confirm_password: "",
          });
        }
      } catch (err) {
        // console.log(err);
        Toaster.error(err?.response?.data?.message);
      } finally {
        setPasswordBtn(false);
      }
      // API call to update password can be placed here
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleCloseMdl = () => {
    setModalCentered(false);
    setPasswordFormData({
      old_password: "",
      password: "",
      confirm_password: "",
    });
  }

  return (
    <>
      <ToastContainer />
      <PageTitle activeMenu="Edit Profile" motherMenu={"Profile"} />
      <div className="row">
        <div className="col-xl-12 col-lg-4">
          <div className="clearfix">
            <div className="card card-bx profile-card author-profile mb-3">
              <div className="card-body">
                <div className="d-flex justify-content ps-3">
                  <button
                    type="submit"
                    className="btn text-primary mt-3 "
                    onClick={() => navigate(-1)}>
                    <FaArrowLeft /> Go back
                  </button>
                </div>
                <div className="py-3 px-2">

                  <div className="position-relative"></div>
                  <div className="author-profile">

                    <div className="author-media">
                      <img
                        className="profle-user-image mt-0"
                        src={
                          uploadProfileUrl
                            ? uploadProfileUrl
                            : profileUrl
                              ? `${apis?.baseurl?.Baseimageurl}${formData?.profileImage}`
                              : userAvatar
                        }
                        alt="profile"
                      />
                      <div
                        className="upload-link"
                        title=""
                        data-toggle="tooltip"
                        data-placement="right"
                        data-original-title="update">
                        <input
                          type="file"
                          className="update-flie"
                          name="profileImage"
                          onChange={handleProfileUpload}
                        />
                        <i className="fa fa-camera"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-12 col-lg-8">
          <div className="card profile-card card-bx">
            <div className="card-header">
              <h6 className="card-title">Basic Info</h6>
              <button
                onClick={() => setModalCentered(true)}
                className="btn btn-link float-end ms-auto">
                Change your password?
              </button>
            </div>
            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-3 mb-3">
                    <label className="form-label">First Name<span className="text-danger">*</span></label>
                    <input
                      className="form-control"
                      type="text"
                      name="firstName"
                      value={formData?.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <span className="text-danger fs-12">
                        {errors.firstName}
                      </span>
                    )}
                  </div>

                  <div className="col-sm-3 mb-3">
                    <label className="form-label">Last Name<span className="text-danger">*</span></label>
                    <input
                      className="form-control"
                      type="text"
                      name="lastName"
                      value={formData?.lastName}
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <span className="text-danger fs-12">
                        {errors.lastName}
                      </span>
                    )}
                  </div>

                  <div className="col-sm-3 mb-3">
                    <label className="form-label">Email<span className="text-danger">*</span></label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      value={formData?.email}
                      disabled
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-3 mb-3">
                    <label className="form-label">Mobile<span className="text-danger">*</span></label>
                    <PhoneInput
                      className=""
                      inputClass=""
                      country={"in"}
                      value={formData?.mobile}
                      onChange={handlePhoneNoChange}
                    />

                    {errors.mobile && (
                      <span className="text-danger fs-12">{errors.mobile}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end card-footer align-items-center d-flex">
                <button type="submit" className="btn btn-primary">
                  {btnLoading && <BtnLoader />} UPDATE
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={modalCentered}
        onHide={handleCloseMdl}
        centered>
        <Modal.Header>
          <Modal.Title>Change Password</Modal.Title>
          <Button
            onClick={handleCloseMdl}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div>
                  {/* Old Password */}
                  <div className="mb-3 row">
                    <div className="col-sm-12 ">
                      <label className="col-form-label">Old Password<span className="text-danger">*</span></label>
                      <div className="position-relative">
                        <input
                          type={showPassword.old_password ? "text" : "password"}
                          name="old_password"
                          value={passwordFormData.old_password}
                          className="form-control"
                          placeholder="Enter Old Password"
                          onChange={handlePasswordInputChange}
                        />
                        <span
                          className="password-toggle-icon"
                          onClick={() =>
                            togglePasswordVisibility("old_password")
                          }>
                          {showPassword.old_password ? (
                            <FaEyeSlash size={20} />
                          ) : (
                            <FaEye size={20} />
                          )}
                        </span>
                      </div>
                      {passwordErrors.old_password && (
                        <span className="text-danger fs-12">
                          {passwordErrors.old_password}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="mb-3 row">
                    <div className="col-sm-12 ">
                      <label className="col-form-label">New Password<span className="text-danger">*</span></label>
                      <div className="position-relative">
                        <input
                          type={showPassword.password ? "text" : "password"}
                          name="password"
                          value={passwordFormData.password}
                          className="form-control"
                          placeholder="Enter New Password"
                          onChange={handlePasswordInputChange}
                        />
                        <span
                          className="password-toggle-icon"
                          onClick={() => togglePasswordVisibility("password")}>
                          {showPassword.password ? (
                            <FaEyeSlash size={20} />
                          ) : (
                            <FaEye size={20} />
                          )}
                        </span>
                      </div>
                      {passwordErrors.password && (
                        <span className="text-danger fs-12">
                          {passwordErrors.password}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="mb-3 row">
                    <div className="col-sm-12 ">
                      <label className="col-form-label">Confirm Password<span className="text-danger">*</span></label>
                      <div className="position-relative">
                        <input
                          type={
                            showPassword.confirm_password ? "text" : "password"
                          }
                          name="confirm_password"
                          value={passwordFormData.confirm_password}
                          className="form-control"
                          placeholder="Confirm New Password"
                          onChange={handlePasswordInputChange}
                        />
                        <span
                          className="password-toggle-icon"
                          onClick={() =>
                            togglePasswordVisibility("confirm_password")
                          }>
                          {showPassword.confirm_password ? (
                            <FaEyeSlash size={20} />
                          ) : (
                            <FaEye size={20} />
                          )}
                        </span>
                      </div>
                      {passwordErrors.confirm_password && (
                        <span className="text-danger fs-12">
                          {passwordErrors.confirm_password}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleCloseMdl}
            variant="danger light">
            Close
          </Button>
          <Button onClick={handlePasswordSubmit} variant="primary">
            {passwordBtn && <BtnLoader />} Save Change
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditProfile;
